"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
require('./overlay.scss');
function Overlay(props) {
  var onClicking = props.onClicking,
    isOpen = props.isOpen,
    onBackgroundClick = props.onBackgroundClick,
    backgroundColor = props.backgroundColor,
    zIndex = props.zIndex;
  var style = {};
  if (backgroundColor) {
    style.backgroundColor = backgroundColor;
    style.opacity = 0.7;
  }
  if (zIndex) {
    style.zIndex = zIndex;
  }
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay",
    onClick: onBackgroundClick,
    style: style
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "overlay-content",
    onClick: onClicking
  }, props.children));
}
var _default = exports.default = Overlay;